export enum PaymentDialog {
  eveeProtect = 'eveeProtect',
  securityDeposit = 'securityDeposit',
  extraPayment = 'extraPayment',
  roadsideAssistance = 'roadsideAssistance',
}
